module.exports = __webpack_public_path__ + "static/mental_health_australia-825b062d71f832c014b47c5046c62a0b.png";